module.exports = __webpack_public_path__ + "static/RST-PIO-CAN-1-56ba191671675642c0f3e52faa5fe4af.jpg";